import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as Sauce from "Sauce";
import * as Immutable from "Immutable";
import * as DND from "react-dnd";
import $ = require("jquery");
import { Latex } from "UI/Math/Latex";
import { EdgeWeightedAdjacencyMatrixGraph } from "Math/Graph";
import { GraphBuilder, NodeProps as GraphBuilderNodeProps, EdgeProps as GraphBuilderEdgeProps } from "UI/Math/GraphBuilder";
import { MatrixViewer, Props as GraphViewProps } from "UI/Math/MatrixViewer";
import { Collapse, Button } from "reactstrap";
import { NumberInput } from "Sauce/Form";
import { NumericMatrix } from "UI/Math/Matrix";
import { Matrix } from "Math/Matrix";
import { ParseResult } from "Sauce/Validation";
import { AnyReal, AnyRealExpression } from "Sauce/Validation/Basic";
import * as Rx from "rxjs";
import * as d3 from "d3";

type Graph = EdgeWeightedAdjacencyMatrixGraph<GraphBuilderNodeProps, GraphBuilderEdgeProps>;
class MarkovText extends Sauce.Component<{}, { open: boolean }> {
    constructor(props: {}) {
        super(props);
        this.state = { open: false };
    }
    toggle = () => {
        this.setState({ open: !this.state.open });
    }

    render() {
        return <div>
            <Button onClick={this.toggle} style={{ marginBottom: '1rem' }}>{this.state.open ? "Hide" : "Show"}</Button>
            <Collapse isOpen={this.state.open}>
                <div className={"markov"}>
                    A markov chain can be represented as a graph. 
                    
                    Each node in the graph is a possible state that the system can have.
                    Each edge of the graph is a transition probability from one state to another.
                    
                    In mathematics this kind of graph is also known as a stochastic process.

                    A markov chain can also be represented as the adjacency matrix of a markov graph. This representation allows us to do useful linear algebra and discover some latent properties of markov chains.
            </div>
            </Collapse>
        </div>
    }
}

interface MarkovProps {  };
class MarkovGraphViewer extends MatrixViewer<GraphBuilderNodeProps, GraphBuilderEdgeProps> { }

interface MarkovState {
    stateVector: Matrix<ParseResult<number>>;
    matrixPower: ParseResult<number>;
}
export class Markov extends Sauce.Component<MarkovProps, MarkovState> 
{ 
    private graph: EdgeWeightedAdjacencyMatrixGraph<GraphBuilderNodeProps, GraphBuilderEdgeProps>;
    private graphSubscription: Rx.Subscription;
    constructor(props: MarkovProps) {
        super(props);
        const { params } = props as any;
        this.state = { 
            stateVector: Matrix.make<ParseResult<number>>(0, 1, () => AnyReal(0), _ => _.formatted ? _.formatted : _.raw),
            matrixPower: AnyReal(1)
        }

        let matrix = Matrix.make<ParseResult<number>>(0, 1, () => AnyReal(0), _ => _.value.toPrecision(3));

        if (params.graphSerialization) {
            this.graph = EdgeWeightedAdjacencyMatrixGraph.deserialize<GraphBuilderNodeProps, GraphBuilderEdgeProps>(params.graphSerialization);
        }
        else {
            this.graph = new EdgeWeightedAdjacencyMatrixGraph<GraphBuilderNodeProps, GraphBuilderEdgeProps>(() => ({ weight: 0, weightParseResult: AnyReal(0) }));
        }
    }

    graphChanged = (g: Graph) => {
        if (g.order() > this.state.stateVector.rows) {
            this.setState({ stateVector: this.state.stateVector.grow(g.order() - this.state.stateVector.rows)})
        }
        else if (g.order() < this.state.stateVector.rows) {
            this.setState({ stateVector: this.state.stateVector.shrink(this.state.stateVector.rows - g.order())})
        }
        this.forceUpdate();
    }
    componentDidMount() {
        this.subscribe(this.graph.graphChanged, this.graphChanged);
    }
    componentWillReceiveProps(newProps: MarkovProps) {
        const { params } = newProps as any;
        let graph = this.graph;
        if (params.graphSerialization) {
            // graph = EdgeWeightedAdjacencyMatrixGraph<GraphBuilderNodeProps, GraphBuilderEdgeProps>.deserialize(params.graphSerialization);
        }
        if (this.graph !== graph) {
            this.graph = graph;
            if (this.graphSubscription) {
                this.remove(this.graphSubscription);
            }
            if (graph) {
                this.graphSubscription = this.subscribe(this.graph.graphChanged, g => this.forceUpdate());
            }
        }
    }
    componentWillUnmount() {
        if (this.graphSubscription) {
            this.remove(this.graphSubscription);
        }
    }
    render() {
        const { props, graph} = this;
        let copy = graph.getMatrixCopy();
        let size = 75;

        let nodecount = copy.rows;
        let entries = graph.rawMatrixEntries();
        let columnLabels = d3.range(0, copy.cols).map(idx => graph.getNode(idx).label);
        let copyNumeric = copy.map(e => e.weight);
        let multipiedCopy = d3.range(this.state.matrixPower.value).reduce(prev => prev.multiply(copyNumeric), copyNumeric.map<number>((_, i, j) => i === j ? 1 : 0));
        let multiplicationResult = multipiedCopy.multiply(this.state.stateVector.map(e => e.value));
        let displayResult = multiplicationResult.map(n => AnyReal(n));

        return <div className="markov-container">
                <MarkovText />
                <GraphBuilder graph={this.graph} />
                <div style={{ display: 'flex' }}>
                    <NumericMatrix matrix={copy.map(e => e.weightParseResult)}
                        columnLabels={columnLabels}
                        leftRowLabels={columnLabels}
                        outerHeight={(nodecount + 1) * 75}
                        outerWidth={(nodecount + 1) * 75}
                        flush={(i, j, val) => this.graph.setEdgeByIndex(i, j, { weight: val.value, weightParseResult: val })}/>
                    <div><label>^</label><NumberInput 
                        style={{ width: 40 }}
                        value={this.state.matrixPower} 
                        flush={val => this.setState({ matrixPower: val })}
                        processor={AnyRealExpression}/>
                    </div>
                    <NumericMatrix matrix={this.state.stateVector}
                        outerHeight={(nodecount + 1) * 75}
                        outerWidth={2 * 75}
                        rightRowLabels={columnLabels}
                        columnLabels={["initial state"]}
                        flush={(i, j, val) => this.setState({ stateVector: this.state.stateVector.setEntry(i, j, val)})} />
                </div>
                <NumericMatrix matrix={displayResult}
                    leftRowLabels={columnLabels}
                    outerHeight={multiplicationResult.rows * size}
                    outerWidth={(multiplicationResult.cols + 1) * size}
                />
            </div>;
    }
}

/*

Number of distinct dice faces after n rolls:
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
*/


// WEBPACK FOOTER //
// ./src/code/Markov/Markov.tsx